import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Award, DatabaseProduct } from "../../Api/Database";
import RegisterAward from "./registerAward";
import config from "../../Api/config";
import { useSession } from "../sessionProvider";

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import RegisterImage from "./registerImage";
import ReactGA from "react-ga4";

let serverUrl = window.location.origin;

type FormInputs = {
    file: FileList,
};

interface RegisterVariantProps {
    parent?: DatabaseProduct
}

function RegisterVariant(props: RegisterVariantProps) {

    ReactGA.send({ hitType: "pageview", page: "/register/variant", title: "Register variant" });

    const navigate = useNavigate();
    const notifyError = (err: any) => toast.error(err, { theme: "colored" });
    const notifySuccess = (text: any) => toast.success(text, { theme: "colored" });

    const { handleSubmit, formState: { errors } } = useForm<FormInputs>();
    const { ownerId } = useSession();
    const { productId } = useParams();

    const [parentId, setParentId] = useState(props.parent)
    const [parents, setParents] = useState<DatabaseProduct[]>([]);
    const [selectedParentId, setSelectedParentId] = useState("");

    const [productData, setProductData] = useState({
        title: "",
        description: "",
        price: null as (number | null),
        thumbnail: "",
        image_gallery: [] as string[],
        sap_product_code: "",
        shop_url: "",
    });

    const [userManualData, setUserManualData] = useState({
        "product_presentation": "",
        "video_presentation": "",
        "user_manual": "",
        "cleaning_instructions": ""
    });

    const [sustainabilityData, setSustainabilityData] = useState({
        "co2_imprint": "",
        "recyclate_share_post_consumer": "",
        "recyclate_share_post_industrial": "",
        "recyclate_material_share": "",
        "recyclate_material_type": "",
        "ways_of_recycling": "",
        "discharge_percentage": ""
    });

    const [awards, setAwards] = useState<Award[]>([]);
    const [pictures, setPictures] = useState<any[]>([]);

    useEffect(() => {
        if (parentId?.id) {
            setProductData({
                title: parentId.title,
                description: parentId.description,
                price: null,
                thumbnail: parentId.thumbnail,
                image_gallery: [],
                sap_product_code: "",
                shop_url: "",
            });
        } else {
            if (productId) {
                config.API.getProduct(productId).then((value) => {
                    //setProductData(value)
                    setParents([value]);
                    setParentId(value);
                    setSelectedParentId("0");
                })
            } else {
                // get parent ids
                config.API.getParentProducts(ownerId).then(
                    (value) => {

                        setParents(value.results);
                        setSelectedParentId("0");
                        setProductData(value.results[0]);
                        setParentId(value.results[0])
                        //console.log("Data: ", value.results);
                    }
                ).catch((error) => {
                    console.error("Error in get product API: ", error);
                    notifyError("Error in get product API: " + error);
                })
            }
        }
    }, [parentId])

    const changeProductData = (name: string, data: any): void => {
        setProductData({ ...productData, [name]: data });
    };

    const changeManualData = (name: string, data: any): void => {
        setUserManualData({ ...userManualData, [name]: data });
    };
    const changeSustainabilityData = (name: string, data: any): void => {
        setSustainabilityData({ ...sustainabilityData, [name]: data });
    };


    const onSubmitForm: SubmitHandler<FormInputs> = (data: FormInputs) => {

        //Check if all pictures are valid
        let justPictures: any[] = [];
        pictures.forEach((element) => {
            if (element.image_gallery !== "") {
                justPictures.push(element.image_gallery);
            }
        });

        // Check if there is youtube link that needs to be embeded
        let dataManual = userManualData as any;
        Object.keys(userManualData).forEach((key: string) => {
            if (dataManual[key].includes('youtube')) {

                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = dataManual[key].match(regExp);

                if (match && match[2].length == 11) {
                    dataManual[key] = 'https://www.youtube.com/embed/' + match[2];
                } else {
                    // vrni error
                    notifyError("Error: Invalid youtube link. Make sure video link is enbeded.");
                    return
                }

            }
        });

        // edit product 
        if (parentId) {
            config.API.addProduct(ownerId, {
                ...productData, sustainability: sustainabilityData, user_manual: dataManual, awards: awards, parent_id: parentId.id, image_gallery: justPictures, video_url: "",
            }).then((value) => {
                navigate('/products')
                notifySuccess("Registered product variant '" + productData.title + "'.");
            }).catch(error => {
                console.error("Error in API Issue: ", error);
                notifyError("Error in onboarding API: " + error);
            });
        }else{
            notifyError("parentId is " + parentId);
        }
    }

    return (<>
        <div className="company">

            <RegisterVisual title={(parentId) ? "Register " + parentId.title + " variant" : "Register product variant"} />

            <div className="explorer">

                <form className="form" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    handleSubmit(onSubmitForm)(event);
                }} >

                    {!productId && <>
                        <label><span className="requiredMark">*</span> Product family{" "} </label>
                        <Select
                            required
                            className="template-field selector"
                            defaultValue={(parents.length > 0 && productId === undefined) ? "0" : ""}
                            value={selectedParentId}
                            onChange={(event => {
                                setSelectedParentId(event.target.value);
                                setParentId(parents[parseInt(event.target.value)]);
                            })}
                        >
                            <MenuItem disabled value="Select family product">
                                <em>Family product </em>
                            </MenuItem>
                            {parents ? (
                                parents.map((item, index) => {
                                    return (
                                        <MenuItem
                                            selected={parents[0].id === item.id}
                                            key={item.id}
                                            value={index}
                                            className="issuer-form selector"
                                        >
                                            {item.title}
                                        </MenuItem>
                                    );
                                })
                            ) : (
                                <></>
                            )}
                        </Select>
                    </>}


                    <div>
                        <label> <span className="requiredMark">*</span> Product title{" "} </label>
                        <input type="text" className="issuer-form" name="title" maxLength={400} placeholder="e.g., Product 1" value={productData.title} onChange={(event) => { changeProductData("title", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Description {" "} </label>
                        <input type="text" className="issuer-form" name="description" maxLength={1000} placeholder="e.g., The product can be purchased in several colors." value={productData.description} onChange={(event) => { changeProductData("description", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label>  Price {" "} </label>
                        <input type="number" step="0.01" className="issuer-form" name="price" placeholder="e.g., 20.00 $" value={productData.price === null ? undefined : productData.price} onChange={(event) => { changeProductData("price", event.target.value === "" ? null : parseFloat(event.target.value)); }} ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Thumbnail {" "} </label>
                        <input type="url" className="issuer-form" name="thumbnail" maxLength={1000} placeholder="e.g., https://www.example.com/logo.png" value={productData.thumbnail} onChange={(event) => { changeProductData("thumbnail", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <h4> Image Gallery
                            {/*<input type="url" className="issuer-form" name="image_gallery" maxLength={1000} placeholder="e.g., https://www.example-gallery.com" value={productData.image_gallery } onChange={(event) => { changeProductData("image_gallery", event.target.value); }}  ></input>*/}

                            <button type="button" onClick={() => {
                                setPictures((oldPictures) => {
                                    if (oldPictures != undefined) {
                                        const newPictures = [...oldPictures];
                                        newPictures.push("");
                                        return newPictures;
                                    }
                                    return [""];

                                })
                            }} className="form_btn">Add image</button></h4>

                        {pictures != undefined && pictures.map((val, index) => {
                            return <RegisterImage key={index} data={val} onChange={(newData: Award) => {
                                // update from the form in this award subsection
                                setPictures((oldPictures) => {
                                    const newPictures = [...oldPictures];
                                    newPictures[index] = newData;
                                    return newPictures;
                                })
                            }} onRemove={() => {
                                // remove this entry from awards state.
                                setPictures((oldPictures) => {
                                    const newPictures = [...oldPictures];
                                    newPictures.splice(index, 1)
                                    return newPictures;
                                })
                            }} />
                        })}
                    </div>

                    <div>
                        <label> SAP Product Code{" "} </label>
                        <input type="text" className="issuer-form" name="sap_product_code" maxLength={400} placeholder="e.g., ABC123" value={productData.sap_product_code} onChange={(event) => { changeProductData("sap_product_code", event.target.value); }} ></input>
                    </div>


                    <div>
                        <h4> Awards{" "} <button type="button" onClick={() => {
                            setAwards((oldAwards) => {
                                if (oldAwards != undefined) {
                                    const newAwards = [...oldAwards];
                                    newAwards.push({} as Award);
                                    return newAwards;
                                }
                                return [{} as Award];

                            })
                        }} className="form_btn">Add award</button></h4>

                        {awards != undefined && awards.map((val, index) => {
                            return <RegisterAward key={index} data={val} onChange={(newData: Award) => {
                                // update from the form in this award subsection
                                setAwards((oldAwards) => {
                                    const newAwards = [...oldAwards];
                                    newAwards[index] = newData;
                                    return newAwards;
                                })
                            }} onRemove={() => {
                                // remove this entry from awards state.
                                setAwards((oldAwards) => {
                                    const newAwards = [...oldAwards];
                                    newAwards.splice(index, 1)
                                    return newAwards;
                                })
                            }} />
                        })}
                    </div>

                    <div>
                        {/*<h4> User Manuals{" "} </h4>*/}
                        <h4> Web shop info:{" "} </h4>
                        <div>
                            <label>  Shop link{" "} </label>
                            <input type="url" className="issuer-form" name="shop_url" maxLength={1000} placeholder="e.g., https://www.example-product.com" value={productData.shop_url} onChange={(event) => { changeProductData("shop_url", event.target.value); }} ></input>
                        </div>
                    </div>

                    <div>
                        <h4> Additional product info:{" "} </h4>
                        <div>
                            <label>  Product Presentation{" "} </label>
                            <input type="url" className="issuer-form" name="product_presentation" maxLength={1000} placeholder="e.g., https://www.example-product.com" value={userManualData.product_presentation} onChange={(event) => { changeManualData("product_presentation", event.target.value); }} ></input>
                        </div>

                        <div>
                            <label> Video Presentation{" "} </label>
                            <input type="url" className="issuer-form" name="video_presentation" maxLength={1000} placeholder="e.g., https://www.example-product-composition.com" value={userManualData.video_presentation} onChange={(event) => { changeManualData("video_presentation", event.target.value); }} ></input>
                        </div>

                        <div>
                            <label> User Manual{" "} </label>
                            <input type="url" className="issuer-form" name="user_manual" maxLength={1000} placeholder="e.g., https://www.example-steps.com" value={userManualData.user_manual} onChange={(event) => { changeManualData("user_manual", event.target.value); }} ></input>
                        </div>

                        {/*<div>
                            <label> Cleaning Instructions{" "} </label>
                            <input type="url" className="issuer-form" name="cleaning_instructions " maxLength={1000} placeholder="e.g., https://www.example-instructions.com" value={userManualData.cleaning_instructions  } onChange={(event) => { changeManualData("cleaning_instructions", event.target.value); }} ></input>
                        </div>*/}
                    </div>

                    <div>
                        <h4> Sustainability{" "} </h4>
                        <div>
                            <label> CO2 Imprint{" "} </label>
                            <input type="text" className="issuer-form" name="co2_imprint" maxLength={1000} placeholder="e.g., Low" value={sustainabilityData.co2_imprint} onChange={(event) => { changeSustainabilityData("co2_imprint", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Recyclate Share: Post Consumer{" "} </label>
                            <input type="text" className="issuer-form" name="recyclate_share_post_consumer" maxLength={1000} placeholder="e.g., 25%" value={sustainabilityData.recyclate_share_post_consumer} onChange={(event) => { changeSustainabilityData("recyclate_share_post_consumer", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Recyclate Share: Post Industrial{" "} </label>
                            <input type="text" className="issuer-form" name="recyclate_share_post_industrial" maxLength={1000} placeholder="e.g., 15%" value={sustainabilityData.recyclate_share_post_industrial} onChange={(event) => { changeSustainabilityData("recyclate_share_post_industrial", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Recycled material share:{" "} </label>
                            <input type="text" className="issuer-form" name="recyclate_material_share" maxLength={1000} placeholder="e.g., 90%" value={sustainabilityData.recyclate_material_share} onChange={(event) => { changeSustainabilityData("recyclate_material_share", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Recycled material type:{" "} </label>
                            <input type="text" className="issuer-form" name="recyclate_material_type" maxLength={1000} placeholder="e.g., Material type" value={sustainabilityData.recyclate_material_type} onChange={(event) => { changeSustainabilityData("recyclate_material_type", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label> Ways of Recycling{" "} </label>
                            <input type="text" className="issuer-form" name="ways_of_recycling" maxLength={1000} placeholder="e.g., https://www.example-recycling.com" value={sustainabilityData.ways_of_recycling} onChange={(event) => { changeSustainabilityData("ways_of_recycling", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Discharge Percentage{" "} </label>
                            <input type="text" className="issuer-form" name="discharge_percentage" maxLength={1000} placeholder="e.g., Minimal" value={sustainabilityData.discharge_percentage} onChange={(event) => { changeSustainabilityData("discharge_percentage", event.target.value); }}  ></input>
                        </div>
                    </div>

                    <button className="btn btn-primary" type="submit"> {'Register variant'}</button>
                    <button className="btn btn-secondary" onClick={() => {
                        navigate('/products');
                    }} > Back</button>
                </form>

            </div>

            <Footer />
        </div>
    </>)
}

export default RegisterVariant;
